import Api from './Api'

export default {
  getAmenities(token) {
    const headerData = {
      headers: {
        Authorization: 'Bearer ' + token,
        Accept: 'application/json;version=1.1;sandbox'
      }
    }
    const postData = {
      
    }
    return Api().post('/app/amenities/', postData, headerData)
  },

}
